





































































































































import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { ErrorManager, IQuoteDocumentTag } from '@/models';
import { ISystemError } from '@/models/error/index';
import { setErrorFromAxiosError } from '@/utils/helpers';

import ALPage from '@/components/core/Page/ALPage.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import DocumentTagFormDialog from '@/components/document/DocumentTagFormDialog.vue';

const baseMixins = mixins(auth);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    documentTagFormDialog: InstanceType<typeof DocumentTagFormDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    components: {
      ALPage,
      ErrorAlert,
      ConfirmationDialog,
      DocumentTagFormDialog
    },

    data() {
      return {
        loading: false,
        search: '',

        error: null as ISystemError | null,

        selectedDocument: null as null | IQuoteDocumentTag,
        deleteDialog: false,
        deleteInProgress: false,
        deleteErrorMessage: '',

        headers: [
          {
            text: '',
            align: 'start',
            width: 30,
            sortable: false,
            value: 'note'
          },
          {
            text: '#',
            align: 'center',
            width: 50,
            sortable: false,
            value: 'index'
          },
          {
            text: 'Label',
            sortable: false,
            value: 'tag.label'
          },
          {
            text: '',
            align: 'end',
            sortable: false,
            value: 'actions'
          }
        ]
      };
    },

    computed: {
      ...mapGetters({
        getQuoteDocumentTags: 'document/getQuoteDocumentTags'
      }),

      documentTags(): IQuoteDocumentTag[] {
        return this.getQuoteDocumentTags;
      }
    },

    mounted() {
      this.loading = true;
      this.fetchQuoteDocumentTags()
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    methods: {
      moment,

      ...mapActions({
        fetchQuoteDocumentTags: 'document/fetchQuoteDocumentTags',
        deleteQuoteDocumentTag: 'document/deleteQuoteDocumentTag'
      }),

      clearAllErrors() {
        this.error = null;
      },

      openDocumentTagFormDialog(documentTag?: IQuoteDocumentTag) {
        const documentTagFormDialog = this.$refs.documentTagFormDialog;
        documentTagFormDialog.open(documentTag);
      },

      openDocumentTagDeleteDialog(document: IQuoteDocumentTag) {
        this.selectedDocument = document;
        this.deleteDialog = true;
      },

      closeDocumentDeleteDialog() {
        this.deleteDialog = false;
      },

      removeDocument(document: IQuoteDocumentTag) {
        this.deleteInProgress = true;

        this.deleteQuoteDocumentTag(document.id)
          .then(() => {
            this.closeDocumentDeleteDialog();
          })
          .catch(error => {
            this.deleteErrorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.deleteInProgress = false;
          });
      }
    }
  });
